import React from 'react';
import { Tab, Tabs } from 'react-toolbox';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component

import styles from './SettingsTabs.scss';// to import local scss fle

class StudentTabs extends React.Component {

  static propTypes = {
    tabListener: PropTypes.func.isRequired,
    location: PropTypes.shape().isRequired,
  };
  state = {
    index: 0,
    fixedIndex: 1,
    inverseIndex: 1,
  };

  handleTabChange = (index) => {
    this.setState({ index });
    this.props.tabListener(index);
  };

  render() {
    return (
      <div className={cn('col s12', styles.container)}>
        <Tabs index={this.props.location.search === '?reset_password' ? 1 : this.state.index} onChange={this.handleTabChange}>
          <Tab label="Profile" activeClassName={styles.activeClass} />
          <Tab label="Reset Password" activeClassName={styles.activeClass} />
          <Tab label="Billings" activeClassName={styles.activeClass} />
        </Tabs>
      </div>
    );
  }
}

export default StudentTabs;



// WEBPACK FOOTER //
// ./src/components/SettingsTabs/SettingsTabs.js